const API = process.env.REACT_APP_BACKEND_URL;

export const trackAppStore = (section) => {
  try {
    fetch(`${API}/api/track/app-store`, {
      method: "POST",
      keepalive: true,
      credentials: "omit",
      referrerPolicy: "no-referrer",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify({ section }),
    }).catch(() => {});
  } catch {
    /* tracking must never block the download */
  }
};

export const qrTrackingUrl = (section) => `${window.location.origin}/api/get-app?s=${section}`;
